// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"DeleteAccountNotificationModal_modalContent__1BiYj"};